// extracted by mini-css-extract-plugin
export var dropdownIcon = "_s9-6";
export var imgContainer = "_s9-3";
export var menuIcon = "_s9-5";
export var pillWrapper = "_s9-2";
export var pillsContainer = "_s9-1";
export var subscriptionCard = "_s9-0";
export var subscriptionLogo = "_s9-4";